/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RefreshTokenRequestDTO = {
    channel?: RefreshTokenRequestDTO.channel;
    phoneNumber?: string;
    refreshToken?: string;
};

export namespace RefreshTokenRequestDTO {

    export enum channel {
        WEB = 'WEB',
        MOBILE = 'MOBILE',
        POS = 'POS',
    }


}

